<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Propor Propostas</h1>
          <br>  
          <b-row>
           <b-col sm="12" md="6">
              <b-form-group label="Caderno"  invalid-feedback='É obrigatório informar o caderno.'>
                  <b-form-select v-model.trim="$v.form.caderno_proposta_id.$model" :state="chkState('caderno_proposta_id')" placeholder="" class="mb-3" :options='options_cadernos'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-for="(proposta, index) in form.propostas" :key="proposta.id" style="margin-top: 10px">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <vue-editor v-model="proposta.texto"/>
                  </b-form-group>
                </b-col>
              </b-row>   
              <b-row>
                <b-col cols="8"></b-col>
                <b-col cols="4">
                  <b-button variant="danger" v-if="index > 0" v-on:click="removerProposta(index)" style="float: right; margin-left: 10px;">
                    <i class="fa fa-minus"></i>
                  </b-button>
                  <b-button variant="info" v-if="index > 0" v-on:click="adicionarProposta()" style="float: right; margin-left: 10px;">
                    <i class="fa fa-plus"></i>
                  </b-button>
                  <b-button variant="secondary" v-if="index < form.propostas.length - 1" v-on:click="moverProposta(index, index + 1)" style="float: right; margin-left: 10px;">
                    <i class="fa fa-arrow-down"></i>
                  </b-button>
                  <b-button variant="secondary"  v-if="index > 0" v-on:click="moverProposta(index, index - 1)" style="float: right;">
                    <i class="fa fa-arrow-up"></i>
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" md="4">
                  <b-button variant="primary" v-on:click="adicionarProposta()">
                    Adicionar Proposta
                  </b-button>
              </b-col>
          </b-row>          
            </b-col>
          </b-row>
          <b-row v-if="form.propostas.length == 0">
            <b-col cols="4">
              <b-button variant="primary" v-on:click="adicionarProposta()">
                Adicionar Proposta
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="4">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Salvar</span>
            </b-button>
          </b-col>
          <b-col v-else md="4">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="voltar()">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>      
    </b-card>
  </b-col>
</template>
<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'
import { VueEditor } from "vue2-editor";

Vue.component('multiselect', Multiselect)

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect,
    VueEditor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      caderno_proposta_id: {
        required
      }
    }
  },
  mounted () {
    this.carregarCadernos()
  },
  created () {    
    if (!this.validaPerfil()) {
     //this.$router.push('/')
    }
  },
  data () {
    return {
      loading: false,
      conferencia_id: SessionStorage.get('conferencia_atual_id'),   
      form: {
        descricao: '',
        acao_proposta: [],      
        propostas: [{
          'id': null,
          'texto': ''
        }],
        propostas_perguntas: [],
        caderno_proposta_id : null
      },

      titulo_toast: 'Alerta!',  
      options_cadernos: [],
      salvarForm: false,
      check_formularios: false,
      disable_buttons: false,
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }  
  },
  watch: {
    //
  },
  methods: {
    validaPerfil () {
      let perfil = this.$store.state.perfil.perfil     
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    removerProposta (key) {
      this.form.propostas.splice(key, 1)
    },
    adicionarProposta () { 
      this.form.propostas.push({
        id: null,
        texto: ''
      })
    },
    moverProposta (oldIndex, newIndex) {
      while (oldIndex < 0) {
        oldIndex += this.form.propostas.length
      }
      while (newIndex < 0) {
        newIndex += this.form.propostas.length
      }
      if (newIndex >= this.form.propostas.length) {
        var k = newIndex - this.form.propostas.length
        while ((k--) + 1) {
          this.form.propostas.push(undefined)
        }
      }
      this.form.propostas.splice(newIndex, 0, this.form.propostas.splice(oldIndex, 1)[0])
      return this.form.propostas
    },
    carregarCadernos () {
      Vue.http.get('api/proposta').then(response => {
        if (response.body.success) {
          let cadernos = response.body.data.data 
          for (let i = 0; i < cadernos.length; i++) {
            this.options_cadernos.push({value: cadernos[i].id, text: cadernos[i].titulo})
          }
        }
      })
    },
    salvar () {
      let form = this.$v.form
      // let caderno_id = form.caderno_proposta_id.$model;

      let data = {
        caderno_proposta_id: form.caderno_proposta_id.$model,
        propostas: this.form.propostas,
        conferencia_id: this.conferencia_id
      }
      this.loading = true

      Vue.http.post('api/proposta/sugerida', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/proposta/lista-propostas'})
        } else {       
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        if(e.data.errors.propostas[0]){
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(e.data.errors.propostas[0], 'Alerta', 5000)
        }
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())

      for (let i = 0; i < this.form.propostas.length; i++) {
        if(i == 0 && this.form.propostas[i].texto == ''){
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error('Adicione ao menos uma proposta!', 'Alerta', 5000)
          return false
        }
      }
      
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    },
    voltar(){
      let voltar = true
      for (let i = 0; i < this.form.propostas.length; i++) {
        if(this.form.propostas[i].texto !== ''){
          voltar = false
        }
      }
      if(this.$v.form.caderno_proposta_id.$model !== null){
         voltar = false
      }

      if(!voltar){
        this.$bvModal.msgBoxConfirm('Tem certeza que deseja voltar? As informações que tenha inserido ou alterado serão perdidas.', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) {
            this.$router.push('/proposta/lista-propostas')
          }
        })
      }
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.groupCheck {
  margin-left: 16px;
}
.check{
  margin-top: 8px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/proporPropostas/PropostaSugestaoCadastrar.vue